import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";

import { getGmu } from "services/gmuToken.service";
import { setServiceError } from "redux/slices/ServiceInlineError";
import { ITokenModel } from "models/Login/token.model";

import { Container, GmuFrame, Spinner } from "components";
import { TokenInclude } from "helpers/GetToken";
import useMerchant from "helpers/hooks/useMerchant";
import usePass from "helpers/hooks/usePass";
import {
  usePassAdminSifre,
  usePassAdminGuvenlik,
} from "helpers/hooks/usePassAdmin";
import useError from "helpers/hooks/useError";

const Dashboard = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isMerchant = useMerchant();
  const IsPasswordChange = usePass();
  const IsPasswordChangeAdmin = usePassAdminSifre();
  const IsPasswordChangeAdminGuv = usePassAdminGuvenlik();
  let err = useError();

  const [inComingMerchantNo, setIncomingMerchantNo] = useState<string>("");
  const [isGmuSuccess, setIsGmuSuccess] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);
  const [gmuUrl, setGmuUrl] = useState("");
  const token = TokenInclude();

  const { merchant, selectedMerchant } = useAppSelector(
    (state) => state.merchant
  );

  //
  const { userOtp } = useAppSelector((state) => state.otp);
  const { user } = useAppSelector((state) => state.login);
  const userName: string = user?.adSoyad!;

  const [merchantName, setMerchantName] = useState("");
  useEffect(() => {
    merchant?.Merchants?.filter(
      (f: any) => f.No === selectedMerchant && setMerchantName(f.Name)
    );
  }, [merchant?.Merchants, selectedMerchant]);
  //
  const {
    firstPassChange,
    firstPassChangeAdmin,
    firstPassChangeAdminGuv,
  } = useAppSelector((state) => state.PassRefPersonelInfo);

  useEffect(() => {
    // if (!userOtp?.IsIgsLocked) {
    setIncomingMerchantNo((selectedMerchant || userOtp?.MerchantNo)!);
    if (userOtp?.UserLevel === "1" || userOtp?.UserLevel === "3") {
      //
      if (IsPasswordChange && !firstPassChange) {
        navigate("/get-password-first");
      } else if (IsPasswordChangeAdmin && !firstPassChangeAdmin) {
        navigate("/get-password-first-admin");
      } else if (IsPasswordChangeAdminGuv && !firstPassChangeAdminGuv) {
        navigate("/admin-security-photo");
      } else if (isMerchant && selectedMerchant === "") {
        navigate("/choice-merchant");
      } else if (token.access_token && !isGmuSuccess && gmuUrl === "" && !err) {
        getGmuToken(token);
      }
    } else {
      //
      if (IsPasswordChange && !firstPassChange) {
        navigate("/get-password-first");
      } else if (IsPasswordChangeAdmin && !firstPassChangeAdmin) {
        navigate("/get-password-first-admin");
      } else if (IsPasswordChangeAdminGuv && !firstPassChangeAdminGuv) {
        navigate("/admin-security-photo");
      } else navigate(`my-profile/${merchantName || userName}`);
    }
    // }

    async function getGmuToken(token: ITokenModel) {
      setIsLoading(true);
      if (!isGmuSuccess) {
        const retVal = await getGmu(token, inComingMerchantNo);
        if (retVal?.DialogBoxes?.length < 1) {
          setGmuUrl(retVal.Url!);

          setIsGmuSuccess(true);
          setIsLoading(false);
        } else {
          const errMessage: any = retVal;

          setIsLoading(false);
          dispatch(setServiceError(errMessage));
          return;
        }
      }

      setIsLoading(false);
    }
  }, [
    IsPasswordChange,
    firstPassChange,
    isMerchant,
    selectedMerchant,
    navigate,
    token,
    isGmuSuccess,
    err,
  ]);

  // async function getGmuToken(token: ITokenModel) {
  //   setIsLoading(true);
  //   if (!isGmuSuccess) {
  //     const retVal = await getGmu(token, inComingMerchantNo);
  //     if (retVal?.DialogBoxes?.length < 1) {
  //       setGmuUrl(retVal.Url!);

  //       setIsGmuSuccess(true);
  //       setIsLoading(false);
  //     } else {
  //       const errMessage: any = retVal;

  //       setIsLoading(false);
  //       dispatch(setServiceError(errMessage));
  //       return;
  //     }
  //   }

  //   setIsLoading(false);
  // }

  return (
    <Container>
      <Spinner show={isLoading} />
      {isGmuSuccess && <GmuFrame source={gmuUrl} />}
    </Container>
  );
};

export default Dashboard;
